import React from "react";
import PropTypes from "prop-types";
// Material imports
import Grid from "@mui/material/Grid";
import makeStyles from "@mui/styles/makeStyles";
import Typography from "@mui/material/Typography";
import BackIcon from "@mui/icons-material/ArrowBackIos";
// Limitless imports
import { BrandLearningTemplate } from "@limitless/content";
import { useNavigation } from "@limitless/portal";
import OnboardingContainer from "../components/containers/onboarding-container/OnboardingContainer";
import { usePageViewRecorder } from "@limitless/analytics";

const useStyles = makeStyles(theme => ({
    container: {
        margin: "auto",
        backgroundColor: theme.palette.background.default,
        display: "flex",
        alignItems: "center"
    },
    titleContainer: {
        display: "flex",
        alignItems: "center",
        padding: "24px 0px 0px 27px",
        backgroundColor: theme.palette.background.default
    },
    titleText: {
        color: theme.palette.primary.main,
        "&:hover": {
            textDecoration: "underline"
        }
    },
    backIcon: {
        fontSize: "1rem",
        color: theme.palette.primary.main
    },
    titleContent: {
        width: "auto",
        cursor: "pointer"
    }
}));

const ExpertBrandLearningScreen = ({ ctaClick, content, showBackButton = false }) => {
    const { navigate } = useNavigation();
    const { loading, template } = content;
    const classes = useStyles();
    usePageViewRecorder("Onboarding - Brand Learning");

    return (
        <OnboardingContainer loading={loading} disableTitle>
            {showBackButton && (
                <Grid className={classes.titleContainer}>
                    <Grid
                        container
                        alignItems="center"
                        className={classes.titleContent}
                        onClick={() => navigate("/onboarding")}
                    >
                        <BackIcon className={classes.backIcon} />
                        <Typography variant="caption" className={classes.titleText}>
                            Back to Onboarding
                        </Typography>
                    </Grid>
                </Grid>
            )}
            {template ? (
                <Grid
                    className={classes.container}
                    xs={12}
                    sm={12}
                    lg={12}
                    md={12}
                    style={showBackButton ? { paddingTop: 34 } : {}}
                >
                    <BrandLearningTemplate content={content} brandLearningCtaClick={ctaClick} />
                </Grid>
            ) : (
                <div />
            )}
        </OnboardingContainer>
    );
};

ExpertBrandLearningScreen.propTypes = {
    ctaClick: PropTypes.func.isRequired,
    content: PropTypes.object.isRequired,
    showBackButton: PropTypes.bool
};

export default ExpertBrandLearningScreen;
